//AWS and REACT Libraries 

import React from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

//page components
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';

//boostrap components 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LoggedInBanner from '../components/LoggedInBanner.js';


export const UserPage = () => {
  const { isPending } = useAuthenticator((context) => [
    context.isPending,
  ]);
  const loading = isPending;

  return (
    <div className='App'>
      <Modal show={loading} centered backdrop="static" keyboard={false}>
        <Modal.Body style={{ textAlign: 'center', fontSize: '1.2em' }}>
          <Spinner animation="border" role="status" style={{ marginBottom: '1em' }} />
          <div>Website loading...logging you into the MHB Portal</div>
        </Modal.Body>
      </Modal>
      <div className='hidden'>
        <Banner/>
      </div>
      <NavMenu/> 

      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            <div className='leftContent text-center'>
              <h2 className='UserNewsDashboard emphTitle padding'>LOG IN</h2>
            </div>              
          </Col>
          <Col xs={12} md={12} lg={12} xl={12}>
            <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp> 
              <h3 className='notice whiteFont empTitle text-center'> You are now logged into the Metro Housing Boston Property manager Portal</h3>
              <LoggedInBanner/>
            </Authenticator>  
            <br />
          </Col>
        </Row>
      </Container>
      <SITELINKS/> 
    </div>
  );
};